class i {
  /**
   * 构造函数
   * @param inputElement - 要应用自动完成功能的输入元素
   * @param apiKey - Google Maps API 密钥
   * @param options - 自动完成选项
   */
  constructor(e) {
    this._language = "en", this._autocomplete = null, this._isUseShortState = !1, this._inputElement = e.inputElement, this._apiKey = e.apiKey, this._options = e.options ?? {}, this._chooseCallBack = e.onChooseAddress, this._language = e.language ?? "en", this._isUseShortState = e.isUseShortState ?? !1;
  }
  /**
   * 加载 Google Maps JavaScript API 脚本
   * @returns Promise<void>
   */
  _loadScript() {
    return new Promise((e, t) => {
      if (window.googleScriptLoaded) {
        e();
        return;
      }
      const o = document.createElement("script");
      o.src = `https://maps.googleapis.com/maps/api/js?v=beta&key=${this._apiKey}&libraries=places${this._language ? `&language=${this._language}` : ""}`, o.async = !0, o.onload = () => {
        window.googleScriptLoaded = !0, e();
      }, o.onerror = () => {
        t(new Error("Failed to load Google Maps script"));
      }, document.body.appendChild(o);
    });
  }
  /**
   * 初始化 Google Maps Places Autocomplete
   * @returns Promise<void>
   */
  async init() {
    try {
      if (await this._loadScript(), !window.googleScriptLoaded)
        throw new Error("Google Maps JavaScript API is not loaded.");
      this._autocomplete || (this._autocomplete = new google.maps.places.Autocomplete(this._inputElement, this._options), this._inputElement.addEventListener("change", (e) => {
        const t = this._inputElement.placeholder;
        return this._inputElement.disabled && setTimeout(() => {
          this._inputElement.placeholder = t, this._inputElement.style.backgroundImage = "", this._inputElement.disabled = !1;
        }, 0), e;
      }), this._inputElement.addEventListener("blur", (e) => {
        const t = this._inputElement.placeholder;
        return this._inputElement.disabled && setTimeout(() => {
          this._inputElement.placeholder = t, this._inputElement.style.backgroundImage = "", this._inputElement.disabled = !1;
        }, 0), e;
      })), this._autocomplete.addListener("place_changed", () => {
        try {
          if (!this._autocomplete)
            throw new Error("Autocomplete object is not initialized.");
          const e = this._autocomplete.getPlace(), t = this._getAddressDetails(e);
          e != null && e.geometry && (this._chooseCallBack(t), sessionStorage.setItem("GoogleAddress", JSON.stringify(t)));
        } catch (e) {
          console.error(e);
          return;
        }
      });
    } catch (e) {
      console.error(e);
    }
  }
  _getAddressDetails(e) {
    const t = {
      address1: "",
      postcode: "",
      locality: "",
      state: "",
      country: "",
      suffixPostcode: "",
      prefixPostcode: ""
    };
    for (const o of e.address_components)
      switch (o.types[0]) {
        case "street_number": {
          t.address1 = `${o.long_name} ${t.address1}`;
          break;
        }
        case "route": {
          t.address1 += o.long_name;
          break;
        }
        case "postal_code": {
          t.postcode = o.long_name;
          break;
        }
        case "postal_code_suffix": {
          t.suffixPostcode = o.long_name;
          break;
        }
        case "postal_code_prefix": {
          t.prefixPostcode = o.long_name;
          break;
        }
        case "locality":
          t.locality = o.long_name;
          break;
        case "administrative_area_level_1": {
          t.state = this._isUseShortState ? o.short_name : o.long_name;
          break;
        }
        case "country":
          t.country = o.long_name;
          break;
      }
    return t;
  }
}
export {
  i as default
};
//# sourceMappingURL=GoogleAutoComplete.mjs.map
